export default __webpack_public_path__ + "static/media/p2.d15070b8.png";